import React from "react"
import types from "prop-types"
import clsx from "clsx"
import { useHistoricalAccessToolContext } from "contexts/HistoricalAccessToolContext"
import { Checkbox } from "shared/checkboxes"

const HistoricalAccessToolTaskForm = ({ className = "", id, title }) => {
  const { deselectTaskForm, isTaskFormSelected, selectTaskForm } = useHistoricalAccessToolContext()

  const formIsSelected = isTaskFormSelected(id)

  const toggleSelection = formIsSelected
    ? () => deselectTaskForm(id)
    : () => selectTaskForm(id)

  return (
    <div className={clsx(className, "flex")}>
      <Checkbox
        className="cursor-pointer mr-2"
        uuid={id}
        value={formIsSelected}
        onChange={toggleSelection}
      />
      <label htmlFor={id} className="cursor-pointer">
        {title}
      </label>
    </div>
  )
}

HistoricalAccessToolTaskForm.propTypes = {
  className: types.string,
  id: types.number.isRequired,
  title: types.string.isRequired,
}

export default HistoricalAccessToolTaskForm
